export default __webpack_public_path__ + "static/media/icon-hand.31ed4b4e.png";